import { useEffect } from 'react'
import { ralphApi } from '../api'
import { useAppStore } from '../stores/app-store'

export function ConfigPanel() {
  const {
    authenticated,
    maxIterations, setMaxIterations,
    completionPromise, setCompletionPromise,
    maxBudgetUsd, setMaxBudgetUsd,
    llmProvider, setLlmProvider,
    llmStatus, setLlmStatus,
    llmLoading, setLlmLoading,
    llmError, setLlmError
  } = useAppStore()

  useEffect(() => {
    if (!authenticated) return

    let cancelled = false

    const load = async () => {
      setLlmLoading(true)
      setLlmError('')
      try {
        const status = await ralphApi.getLlmProviders()
        if (!cancelled) {
          setLlmStatus(status)
        }
      } catch (err) {
        if (!cancelled) {
          setLlmStatus(null)
          setLlmError(err instanceof Error ? err.message : 'Failed to load provider plans')
        }
      } finally {
        if (!cancelled) {
          setLlmLoading(false)
        }
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [authenticated, setLlmError, setLlmLoading, setLlmStatus])

  return (
    <div className="card config-panel">
      <div className="card-header">
        <span className="card-title">Config</span>
      </div>

      <div className="config-grid">
        <div className="config-item">
          <label>Max Iterations</label>
          <input
            type="number"
            className="config-input"
            value={maxIterations}
            onChange={(e) => setMaxIterations(parseInt(e.target.value) || 1)}
            min={1}
            max={200}
          />
        </div>

        <div className="config-item">
          <label>Provider Plan</label>
          <select
            className="config-input"
            value={llmProvider}
            onChange={(e) => setLlmProvider(e.target.value as 'auto' | 'anthropic' | 'minimax' | 'zai')}
          >
            <option value="auto">Auto</option>
            <option value="anthropic">Anthropic</option>
            <option value="minimax">MiniMax AI</option>
            <option value="zai">Z.ai</option>
          </select>
        </div>

        <div className="config-item">
          <label>Budget ($/iter)</label>
          <input
            type="number"
            className="config-input"
            value={maxBudgetUsd}
            onChange={(e) => setMaxBudgetUsd(parseFloat(e.target.value) || 1)}
            min={0.5}
            step={0.5}
          />
        </div>

        <div className="config-item full-width">
          <label>Promise</label>
          <input
            type="text"
            className="config-input"
            value={completionPromise}
            onChange={(e) => setCompletionPromise(e.target.value)}
            placeholder="DONE"
          />
        </div>

        <div className="config-item full-width">
          <label>Token Plans</label>
          <div className="provider-plan-grid">
            {llmStatus?.plans.map((plan) => (
              <div key={plan.provider} className={`provider-plan ${plan.configured ? 'is-ok' : 'is-missing'}`}>
                <div className="provider-plan-header">
                  <span>{plan.label}</span>
                  <span className="provider-plan-state">{plan.configured ? 'configured' : 'missing'}</span>
                </div>
                <div className="provider-plan-model">{plan.defaultModel}</div>
              </div>
            ))}
            {!llmStatus && !llmLoading && !llmError && (
              <div className="provider-plan provider-plan-empty">No provider data yet.</div>
            )}
          </div>
          {(llmStatus?.message || llmError || llmLoading) && (
            <div className="provider-plan-note">
              {llmLoading ? 'Loading provider plans...' : (llmError || llmStatus?.message)}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
